import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './MapExpander.module.scss';
import isEmpty from '../../utils/isEmpty';
import Map from '../Map';
import { useTranslation } from 'next-i18next';

const MapExpander = ({ googleMapsApiKey, items = [], zoomLevel = 14 }) => {
    const { t } = useTranslation('common');
    const [isOpen, setIsOpen] = useState(false);

    if (isEmpty(items)) {
        return null;
    }

    items = items.map((item) => ({
        ...item,
        readMore: item?.url ? null : t('mapExpander.goToMap'),
        href:
            item?.url ||
            `https://maps.google.com/maps/dir/${item.lat},${item.lng}/@${item.lat},${item.lng},16z`,
    }));

    return (
        <div className={styles['MapExpander']}>
            <button
                onClick={() => setIsOpen((p) => !p)}
                aria-controls="article_map"
                aria-expanded={isOpen}
                className={styles['MapExpander__Button']}>
                {t('mapExpander.defaultIfNoAddress')}
            </button>
            {isOpen && (
                <div className={styles['MapExpander__Expand']}>
                    <Map
                        apiKey={googleMapsApiKey}
                        items={items}
                        zoomLevel={zoomLevel}
                        untranslatedModifiers={['Map--InExpander']}
                    />
                </div>
            )}
        </div>
    );
};

MapExpander.propTypes = {
    googleMapsApiKey: PropTypes.string,
    items: PropTypes.array,
    zoomLevel: PropTypes.number,
};

export default MapExpander;
